import React from 'react'
import { Link } from 'react-router-dom'
import SlotAdd from './CruiseTripSlotAdd'
import Constant from '../../../Constant'

class CruiseTripSlotAddTab extends React.Component {
  state = {
    language_data: [],
  }

  componentDidMount() {
    if (
      this.props.match.params.tripId !== undefined &&
      this.props.match.params.tripId !== null &&
      this.props.match.params.tripId !== 0 &&
      this.props.match.params.tripId !== ''
    ) {
      this.setState({ trip_id: this.props.match.params.tripId })
    }
    this.getLanguageList()
  }

  getLanguageList = () => {
    var language_data = Constant.getLanguageList()
    this.setState({
      ...this.state,
      language_data: language_data,
      language_id: language_data[0].id,
      isLoading: false,
    })
  }

  handleLanguage = (language_id) => {
    this.setState({ language_id: language_id })
  }

  render() {
    return (
      <div className="main-body">
        <div className="page-wrapper">
          <div className="page-header">
            <div className="row align-items-end">
              <div className="col-lg-8">
                <div className="page-header-title">
                  <div className="d-inline">
                    <h4>
                      Cruise Trip Slot
                      {this.props.match.params.id ? ' Edit' : ' Add'}
                    </h4>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="page-header-breadcrumb">
                  <ul className="breadcrumb-title">
                    <li className="breadcrumb-item">
                      <Link to="/">
                        <i className="feather icon-home"></i>{' '}
                      </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to={`/cruise-trip-slots/${this.props.match.params.destinationId}/${this.props.match.params.tripId}`}> Cruise Trip Slot List</Link>
                    </li>
                    <li className="breadcrumb-item active">
                      Cruise Trip Slot
                      {this.props.match.params.id ? 'Edit' : 'Add'}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-border-default">
                  <div className="card-block">
                    <div className="tab-content tabs">
                      <div
                        className="tab-pane  active"
                        id={'Products_add_' + this.state.language_id}
                        role="tabpanel"
                        aria-labelledby=""
                      >
                        {this.props.match.params.id !== undefined &&
                          this.props.match.params.id !== null &&
                          this.props.match.params.id !== 0 &&
                          this.props.match.params.id !== '' ? (
                          <SlotAdd
                            language_id={this.state.language_id}
                            goBack={this.props.history.goBack}
                            tripId={this.state.trip_id}
                            id={this.props?.match?.params?.id}
                          />
                        ) : (
                          <SlotAdd
                            language_id={this.state.language_id}
                            goBack={this.props.history.goBack}
                            tripId={this.state.trip_id}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default CruiseTripSlotAddTab
